import { useCallback, useEffect, useRef, useState } from 'react'

const useShowDetails = () => {
  const [showDetails, setShowDetails] = useState(false)
  const boxRef = useRef()
  const onShowAmount = () => {
    setShowDetails((prevState) => !prevState)
  }
  const onOpen = useCallback(() => {
    setShowDetails(true)
  }, [])
  const onCLose = useCallback(() => {
    setShowDetails(false)
  }, [])
  useEffect(() => {
    if (showDetails && boxRef.current) {
      boxRef.current.scrollIntoView()
    }
  }, [showDetails])
  return { showDetails, boxRef, onShowAmount, onCLose, onOpen }
}

export default useShowDetails
